/*
 * @Author: 陈乾
 * @Date: 2021-07-29 09:46:00
 * @LastEditors: 陈乾
 * @LastEditTime: 2025-09-19 15:01:05
 * @Description: file content
 * @FilePath: /Cheers 上线速览/src/main.js
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant from 'vant'
import utils from './utils/index'
import api from './api/index'
import cqIcon from './components/icon/icon'
import Mixins from './mixins/method'
import VConsole from 'vconsole'

if (process.env.NODE_ENV != 'production') {
  new VConsole()
}
import 'vant/lib/index.css'
import 'lib-flexible'
Vue.use(Vant)
Vue.mixin(Mixins)

Vue.config.productionTip = false
Vue.prototype.$utils = utils
Vue.prototype.$api = api
Vue.component('cqIcon', cqIcon)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
